import { Injectable } from '@angular/core';
import { HandledHttpClient } from '../api/handledHttpClient';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SearchApiService {
  private baseUrl: string;

  constructor(private http: HandledHttpClient) {
    this.baseUrl = environment.config.apis.search.replace(/\/+$/, '');
  }
  /**
   *
   * @param keyword searchtext
   * get matched questions as group by searchText From QuestionBank
   */
  getDrillDownQuestions<T>(keyword: string) {
    const encodedKeyword = encodeURIComponent(keyword ?? '');
    return this.http.get<T[]>(this.baseUrl + '/Section/search?keyword=' + encodedKeyword, {
      errorMessage: `Error retrieving application from the service for keyword = '${keyword}'`,
    });
  }

  /**
   *
   * @param keyword searchText
   * get matched individual questions by entered keyword from question bank
   */
  getKeyWordQuestions<T>(keyword: string) {
    const encodedKeyword = encodeURIComponent(keyword ?? '');
    return this.http.get<T[]>(
      this.baseUrl + '/question/search?keyword=' + encodedKeyword,
      {
        errorMessage: `Error retrieving application from the service for keyword = '${keyword}'`,
      }
    );
  }
}
